import PropTypes from "prop-types";
import styled from "styled-components";
import SearchIcon from "assets/icons/search.svg";

export const SearchForm = styled.form`
  display: flex;
  gap: 4px;
  padding: 8px 16px;
  height: ${({
    // @ts-ignore
    height,
  }) => (height ? height : "48px")};
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  background-color: #fff;
  width: ${({
    // @ts-ignore
    width,
  }) => (width ? width : "100%")};
  min-width: 150px;

  input {
    font-size: 14px;
    width: 100%;
    border: none;
    background-color: inherit;

    &::placeholder {
      color: var(--grey_9);
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }

    &:focus {
      outline: none;
    }
  }
  input[type="search"]::-webkit-search-cancel-button {
    display: none;
  }
`;
/**
 * @param {Object} props
 * @param {string} props.keyword - value of search
 * @param {any} [props.setKeyword] - setter for keyword
 * @param {Function} [props.handleSearch] - function to search
 * @param {string} [props.placeholder]
 * @param {string} [props.height] - height of input field
 * @param {string} [props.width] - specify preferred width of input field
 * @param {string} [props.className] - pass preferred style or target input field
 * @param {any} [props.onFocus]
 * @param {string | number} [props.onFocus]  -
 */
const SearchBar = ({
  keyword,
  setKeyword,
  handleSearch,
  placeholder,
  height,
  width,
  className,
  onFocus,
}) => {
  return (
    <SearchForm
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
      //@ts-ignore
      height={height}
      width={width}
    >
      <img
        src={SearchIcon}
        alt="search"
        className="search-icon"
        width={"20px"}
      />

      <input
        type="search"
        value={keyword}
        placeholder={placeholder || "Search"}
        onChange={(e) => {
          setKeyword(e.target.value);
        }}
        onFocus={onFocus}
      />
    </SearchForm>
  );
};

SearchBar.propTypes = {
  keyword: PropTypes.string,
  setKeyword: PropTypes.func,
  handleSearch: PropTypes.func,
  placeholder: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};
export default SearchBar;
